module.exports = __webpack_public_path__ + "static/pattern-stripe.014b344a.svg";